module.exports = __webpack_public_path__ + "img/744.8ff75101.jpg";